import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Overlaytext from "../components/Overlaytext/Overlaytext";

const GalleryPage = () => {
  const galleryItems = [
    {
      id: 1,
      title: "Sales Training Workshop",
      category: "Training",
      image: "🎓",
      description:
        "Our team conducting a comprehensive sales training workshop for client teams.",
    },
    {
      id: 2,
      title: "Client Success Meeting",
      category: "Consulting",
      image: "🤝",
      description:
        "Strategic planning session with one of our long-term clients.",
    },
    {
      id: 3,
      title: "Analytics Dashboard",
      category: "Technology",
      image: "📊",
      description:
        "Custom sales analytics dashboard we developed for a client.",
    },
    {
      id: 4,
      title: "Award Ceremony",
      category: "Recognition",
      image: "🏆",
      description: "Receiving the 'Best Sales Consultancy' award for 2024.",
    },
    {
      id: 5,
      title: "Team Building Event",
      category: "Team",
      image: "👥",
      description:
        "Annual team building event to strengthen our company culture.",
    },
    {
      id: 6,
      title: "Client Presentation",
      category: "Presentation",
      image: "📈",
      description:
        "Presenting sales growth strategies to a Fortune 500 company.",
    },
  ];

  const categories = [
    "All",
    "Training",
    "Consulting",
    "Technology",
    "Recognition",
    "Team",
    "Presentation",
  ];

  return (
    <div className="App">
      <Header />

      <Overlaytext title="Gallery" subtitle="Explore our work, events, and achievements" backgroundImage=" https://images.unsplash.com/photo-1758873268877-3cd8ed329ed8?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=3132 " />


      {/* Filter Section */}
      <section className="gallery-filter">
        <div className="container">
          <div className="filter-buttons">
            {categories.map((category) => (
              <button key={category} className="filter-btn">
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-main">
        <div className="container">
          <div className="gallery-grid">
            {galleryItems.map((item) => (
              <div key={item.id} className="gallery-item">
                <div className="gallery-image">
                  <div className="image-placeholder">{item.image}</div>
                  <div className="gallery-overlay">
                    <button className="view-btn">View Details</button>
                  </div>
                </div>
                <div className="gallery-content">
                  <span className="gallery-category">{item.category}</span>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="gallery-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>200+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Training Sessions</p>
            </div>
            <div className="stat-item">
              <h3>15+</h3>
              <p>Awards Won</p>
            </div>
            <div className="stat-item">
              <h3>100%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GalleryPage;
